// extracted by mini-css-extract-plugin
module.exports = {"articleSection":"article_articleSection__feSpl","noLinkStyle":"article_noLinkStyle__QDaoc"};